import { ajax, axios } from '#utils'
import {RequestOptions} from "#utils/axios";

export type ReqOpts = RequestOptions & {
  silent?: boolean,
  toRubby?: boolean,
  // postDownload.js 运行时读取的是小写 filename（覆盖 Content-Disposition 解析出的文件名），
  // 但 RequestOptions 仅声明了驼峰 fileName，二者历史不一致。此处补齐以保证类型安全。
  filename?: string,
};

export default async <T>(url: string, opts: ReqOpts): Promise<T> => {
  const { data, ...restOpts } = opts
  if (restOpts.toRubby) {
    return axios({ openapi: true, url: url.replace(/(v\d+)/, '$1/java_proxy'), body: data, ...restOpts }).catch(err => {
      // 报错时的返回结构转ruby
      const errRes = err?.response;
      // ruby 的login接口错误信息在 res.res_msg 上
      // ruby 的reset接口错误信息要放在 res.data.message 上
      const errMessage = errRes?.data?.message;
      // ruby 的check_reset_link接口错误code 为 -1
      const url = err?.config?.url || '';
      const check_reset_link = url.includes('check_reset_link')
      const errInfo = {
        res_code: check_reset_link ? -1 : 0,
        res_msg: errMessage,
        data: {
          messages: errMessage,
          ...(errRes?.data || {}),
        }
      }
      return errInfo;
    })
  }
  return axios({ openapi: true, url: url.replace(/(v\d+)/, '$1/java_proxy'), body: data, ...restOpts })
}
